import PendingActionWindowIcon from './PendingActionWindowIcon'

export default PendingActionWindowIcon
